<template>
  <div class="main-container">
    <template v-if="false">
      <h1>
        Reusable Multi-fuctional WorkFlowchart - Vue Component (library)
      </h1>
      <code>
        JSON Tree Structure - add/remove - drag and drop {{ sourceNode }} ::{{ targetNode }}
      </code>
    </template>
    <button
      class="btn btn-primary btn-save"
      @click="saveTree()"
    >
      Save
    </button>
    <!-- <SvgPanZoom class="parent-canvas"  :fit="false"  @svgpanzoom="registerSvgPanZoom" :controlIconsEnabled="true" :center="true" :mouseWheelZoomEnabled="false" :zoomEnabled="false"> -->
    <div class="parent-canvas">
      <div class="control-canvas">
        <div v-if="false">
          <span>{{ Math.ceil(zoomRate * 100) }}%</span>
        </div>
        <div
          class="control-zoomin is-top"
          @click="zoomIn()"
        ><span>+</span></div>
        <div
          class="control-zoomin is-bottom"
          @click="zoomOut()"
        ><span>-</span></div>
      </div>
      <svg
        :width="canvas.width*zoomRate"
        :height="canvas.height*zoomRate"
      >
        <g :transform="'scale('+ zoomRate + ')'">
          <svg
            id="mainCanvas"
            :width="canvas.width"
            :height="canvas.height"
          >
            <g
              v-for="(node, index) in nodeData"
              :key="node.key"
            >
              <g v-if="!node.same">
                <g v-if="node.multiple">
                  <!-- root -->
                  <g
                    v-for="entry in getMultipleEntry(index)"
                    :key="entry.key"
                  >
                    <CustomRectangle
                      :text="entry.text"
                      :cx="getNodeInfo(getIndexFromKey(entry.key)).x"
                      :cy="getNodeInfo(getIndexFromKey(entry.key)).y + unitPixel / 4"
                      :dx="getNodeInfo(getIndexFromKey(entry.key)).dx / 1.2"
                      :dy="sizes.rectHeight"
                      :arrayIndex="getIndexFromKey(entry.key)"
                      :category="null"
                    />
                    <CustomSpline
                      :sx="getNodeInfo(index).x"
                      :sy="getNodeInfo(index).y + unitPixel * 3.1"
                      :ex="getNodeInfo(getIndexFromKey(entry.key)).x"
                      :ey="getNodeInfo(getIndexFromKey(entry.key)).y + unitPixel * 1.25"
                    />
                  </g>
                  <!-- add entry -->
                  <CustomRectangle
                    :text="' '"
                    :cx="getNodeInfo(index).x + getNodeInfo(index).dx"
                    :cy="getNodeInfo(index).y + unitPixel / 4"
                    :dx="unitPixel * 5"
                    :dy="sizes.rectHeight"
                    :arrayIndex="null"
                    :answer="null"
                    :category="-1"
                    @click.native="addEntry(index)"
                  />
                  <CustomSpline
                    :sx="getNodeInfo(index).x"
                    :sy="getNodeInfo(index).y + unitPixel * 3.1"
                    :ex="getNodeInfo(index).x + getNodeInfo(index).dx"
                    :ey="getNodeInfo(index).y + unitPixel * 1.25"
                  />
                  <CustomCircle
                    class="add-node"
                    :text="'+'"
                    :cx="getNodeInfo(index).x - unitPixel * 3 / 5.5"
                    :cy="getNodeInfo(index).y + unitPixel * 3 + 1"
                    :radius="sizes.customCircleRadius"
                    :arrayIndex="index"
                    :answer="null"
                    :data-index="index"
                    type="add"
                    :hasChild="hasChildren(index)"
                    @click.native="showCreateModal(index, null, node.key)"
                  />
                </g>
                <g v-else>
                  <!-- general -->
                  <CustomRectangle
                    :model="node"
                    :text="node.text"
                    :cx="getNodeInfo(index).x"
                    :cy="getNodeInfo(index).y"
                    :dx="getNodeInfo(index).dx + 1"
                    :dy="sizes.rectHeight"
                    :arrayIndex="index"
                    :category="node.category"
                  />
                </g>
                <CustomSpline
                  v-if="index > 0"
                  :sx="getNodeInfo(index).x"
                  :sy="getNodeInfo(index).y - unitPixel"
                  :ex="getNodeInfo(index).x"
                  :ey="getNodeInfo(index).y - unitPixel * 2"
                />
                <circle
                  v-if="index > 0"
                  class="circle-top-joint"
                  :cx="getNodeInfo(index).x"
                  :cy="getNodeInfo(index).y - unitPixel"
                  :r="sizes.circleRadius"
                  :data-index="index"
                  :type="'point'"
                />
                <!-- condition -->
                <g
                  v-for="question in node.question"
                  :key="node.key + question"
                >
                  <CustomCircle
                    :text="question"
                    :cx="getChildInfo(index,question).x - unitPixel * 4 / 5 - 1"
                    :cy="getNodeInfo(index).y + unitPixel * 4 - 1"
                    :radius="unitPixel * 4 / 5"
                    type="condition"
                  />
                  <CustomSpline
                    :sx="getChildInfo(index,question).x"
                    :sy="getNodeInfo(index).y + unitPixel * 4"
                    :ex="getNodeInfo(index).x"
                    :ey="getNodeInfo(index).y + unitPixel * 2"
                  />
                  <CustomSpline
                    :sx="getNodeInfo(index).x"
                    :sy="getNodeInfo(index).y + unitPixel + 10"
                    :ex="getNodeInfo(index).x"
                    :ey="getNodeInfo(index).y + unitPixel * 2"
                  />
                  <circle
                    v-if="false"
                    class="circle-bottom-joint"
                    :cx="getChildInfo(index, question).x"
                    :cy="getNodeInfo(index).y + getNodeInfo(index).dy - unitPixel * 5.5"
                    :r="sizes.circleRadius"
                    :data-index="index"
                    :data-question="question"
                    :type="'point'"
                  />
                  <g v-if="node.goto == null || node.goto[question] == null">
                    <CustomCircle
                      class="add-node"
                      :text="'+'"
                      :cx="getChildInfo(index,question).x - unitPixel * 3 / 5 + 1"
                      :cy="getNodeInfo(index).y + unitPixel * 7 - unitPixel / 2"
                      :radius="sizes.customCircleRadius"
                      :arrayIndex="index"
                      :answer="question"
                      :data-index="`${index}-${question}`"
                      type="add"
                      :hasChild="hasChildren(index, question)"
                      @click.native="showCreateModal(index, question, node.key)"
                    />
                    <CustomSpline
                      :sx="getChildInfo(index, question).x"
                      :sy="getNodeInfo(index).y + unitPixel * 7 - unitPixel / 2"
                      :ex="getChildInfo(index, question).x"
                      :ey="getNodeInfo(index).y + unitPixel * 6 - unitPixel / 2"
                      :y1="3"
                    />
                    <circle
                      v-if="false"
                      class="circle-bottom-joint"
                      :cx="getChildInfo(index, question).x"
                      :cy="getNodeInfo(index).y + getNodeInfo(index).dy - unitPixel * 3.9"
                      :r="sizes.circleRadius"
                      :data-index="index"
                      :data-question="question"
                      :type="'point'"
                    />
                  </g>
                  <!-- (goto) at blank branch of condition -->
<!--                  <g v-if="!hasChildren(index, question)">-->
<!--                    <g v-if="node.goto == null || node.goto[question] == null">-->
<!--                      <circle-->
<!--                        class="circle-term-joint"-->
<!--                        :cx="getChildInfo(index,question).x"-->
<!--                        :cy="getNodeInfo(index).y + getNodeInfo(index).dy - unitPixel * 7 / 4"-->
<!--                        :r="unitPixel / 4"-->
<!--                        :data-index="index"-->
<!--                        :data-question="question"-->
<!--                        :type="'point'"-->
<!--                      />-->
<!--                    </g>-->
<!--                    <g v-else>-->
<!--                      <circle-->
<!--                        class="circle-bottom-joint"-->
<!--                        :cx="getChildInfo(index,question).x"-->
<!--                        :cy="getNodeInfo(index).y + getNodeInfo(index).dy - unitPixel * 3.9"-->
<!--                        :r="unitPixel / 6"-->
<!--                        :data-index="index"-->
<!--                        :data-question="question"-->
<!--                        :type="'point'"-->
<!--                      />-->
<!--                      &lt;!&ndash;(goto)~ line for branch &ndash;&gt;-->
<!--                      <CustomSpline-->
<!--                        :sx="getChildInfo(index,question).x"-->
<!--                        :sy="getNodeInfo(index).y + getNodeInfo(index).dy - unitPixel * 4"-->
<!--                        :ex="getNodeInfo(getIndexFromKey(node.goto[question])).x"-->
<!--                        :ey="getNodeInfo(getIndexFromKey(node.goto[question])).y-unitPixel"-->
<!--                        :index="index"-->
<!--                        type="1"-->
<!--                      />-->
<!--                    </g>-->
<!--                  </g>-->
                </g>
                <!-- -->
                <template v-if="node.category !== actionTypes.END_AUTOMATION">
                  <g v-if="!node.question || node.question.length === 0">
                    <!-- [+] -->
                    <g v-if="node.goto == null">
                      <CustomSpline
                        v-if="!node.multiple && node.category !== actionTypes.GOTO"
                        :sx="getNodeInfo(index).x"
                        :sy="getNodeInfo(index).y + getNodeInfo(index).dy - unitPixel * 4 + 18"
                        :ex="getNodeInfo(index).x"
                        :ey="getNodeInfo(index).y + getNodeInfo(index).dy - unitPixel * 3 + 10"
                      />
                      <CustomCircle
                        v-if="!node.multiple && node.category !== actionTypes.GOTO"
                        class="add-node"
                        :text="'+'"
                        :cx="getNodeInfo(index).x - unitPixel * 3 / 5.5"
                        :cy="getNodeInfo(index).y + getNodeInfo(index).dy - unitPixel * 3"
                        :radius="sizes.customCircleRadius"
                        :arrayIndex="index"
                        :answer="null"
                        :hasChild="hasChildren(index)"
                        :data-index="index"
                        type="add"
                        @click.native="showCreateModal(index, null, node.key)"
                      />
                      <!--(goto) at blank node -->
                      <circle
                        v-if="!node.multiple && !hasChildren(index) && node.category === actionTypes.GOTO"
                        class="circle-term-joint"
                        :cx="getNodeInfo(index).x"
                        :cy="getNodeInfo(index).y + getNodeInfo(index).dy - unitPixel * 12 / 4"
                        :r="unitPixel / 6"
                        :data-index="index"
                        :type="'point'"
                      />
                    </g>
                    <!-- ~ (goto) line -->
                    <g v-else >
                      <CustomSpline
                        :sx="getNodeInfo(index).x"
                        :sy="getNodeInfo(index).y + getNodeInfo(index).dy - unitPixel * 4 + 10"
                        :ex="getNodeInfo(getIndexFromKey(node.goto)).x"
                        :ey="getNodeInfo(getIndexFromKey(node.goto)).y - unitPixel"
                        :index="index"
                        type="1"
                      />
                    </g>
                    <circle
                      v-if="index > 0"
                      class="circle-bottom-joint"
                      :cx="getNodeInfo(index).x"
                      :cy="getNodeInfo(index).y + getNodeInfo(index).dy - unitPixel * 4 + 10"
                      :r="unitPixel / 6"
                      :data-index="index"
                      :type="'point'"
                    />
                  </g>
                  <g v-else >
                    <circle
                      v-if="index > 0"
                      class="circle-bottom-joint"
                      :cx="getNodeInfo(index).x"
                      :cy="getNodeInfo(index).y + unitPixel + 10"
                      :r="unitPixel / 6"
                      :data-index="index"
                      :type="'point'"
                    />
                  </g>
                </template>
              </g>
            </g>
            <!-- drag and drop focus -->
            <VDragAndDropFigures :unitPixel="unitPixel" />
            <!-- control box -->
            <g>
              <VControlBox
                :can-edit="canEditInControlBox"
                @edit="editNode()"
                @remove="removeNode()"
              />
            </g>
          </svg>
        </g>
      </svg>
    </div>
    <!-- </SvgPanZoom> -->

    <ModalCreateAction
      v-if="visibleDiag1"
      @open="hideActionModal($event)"
      @close="visibleDiag1 = false"
    />
    <ModalCreateTrigger
      v-if="modalWindowModels.addTrigger"
      @add="addTrigger($event)"
      @close="hideDiag2()"
    />
    <ModalWait
      v-if="modalWindowModels.wait"
      :mode="actionModalType"
      :model="actionModalModel"
      @add="addNode($event)"
      @save="saveNode($event)"
      @close="hideDiag2()"
    />
    <ModalEmail
      v-if="modalWindowModels.email"
      :mode="actionModalType"
      :model="actionModalModel"
      @add="addNode($event)"
      @save="saveNode($event)"
      @close="hideDiag2()"
    />
    <ModalCondition
      v-if="modalWindowModels.condition"
      :mode="actionModalType"
      :model="actionModalModel"
      @add="addNode($event)"
      @save="saveNode($event)"
      @close="hideDiag2()"
    />
    <ModalIntegration
      v-if="modalWindowModels.integration"
      :mode="actionModalType"
      :model="actionModalModel"
      @add="addNode($event)"
      @save="saveNode($event)"
      @close="hideDiag2()"
    />
    <ModalNotification
      v-if="modalWindowModels.notification"
      :mode="actionModalType"
      :model="actionModalModel"
      @add="addNode($event)"
      @save="saveNode($event)"
      @close="hideDiag2()"
    />
    <ModalWebhook
      v-if="modalWindowModels.webhook"
      :mode="actionModalType"
      :model="actionModalModel"
      @add="addNode($event)"
      @save="saveNode($event)"
      @close="hideDiag2()"
    />
    <ModalDragAndDrop
      v-if="modalWindowModels.dragAndDrop"
      @move="moveCopyNode($event)"
      @close="hideDiag2()"
    />
  </div>
</template>

<script>
import * as d3 from 'd3'
import CustomCircle from '@/components/CustomCircle'
import CustomSpline from '@/components/CustomSpline'
import CustomRectangle from '@/components/CustomRectangle'
import Modal from '@/components/Modal.vue'
import VDragAndDropFigures from '@/components/VDragAndDropFigures.vue'
import VControlBox from '@/components/VControlBox'
import SvgPanZoom from 'vue-svg-pan-zoom'

import {
  ModalCreateAction,
  ModalCreateTrigger,
  ModalWait,
  ModalEmail,
  ModalCondition,
  ModalIntegration,
  ModalNotification,
  ModalWebhook,
  ModalDragAndDrop
} from './modals'

import {
  ActionCategories,
  ActionTypes,
  modalWindowTypes
} from '@/utils/dictionaries'
import ActionNodeFactory from '../utils/factories/ActionNodeFactory'

const nodesFactory = new ActionNodeFactory()

export default {
  name: 'nodeData',
  components: {
    CustomCircle,
    CustomSpline,
    CustomRectangle,
    SvgPanZoom,
    Modal,
    VDragAndDropFigures,
    VControlBox,
    ModalCreateAction,
    ModalCreateTrigger,
    ModalWait,
    ModalEmail,
    ModalCondition,
    ModalIntegration,
    ModalNotification,
    ModalWebhook,
    ModalDragAndDrop
  },
  data: () => (
    {
      canvas: {
        width: 500,
        height: 500
      },
      msg: 'Please check me.',
      unitPixel: 25,
      ax: 0,
      ay: 0,
      zoomRate: 1.0,
      // create node (at terminal)
      selectedNode: null,
      selectedCategory: null,
      selectedQuestion: null,
      // insert node (at middle)
      selectedChild: null,
      // drag and drop
      targetNode: null,
      sourceNode: null,
      sourceQuestion: null,
      targetQuestion: null,
      draging: false,
      // inputValue: null,
      inputCondition: [
        {
          query: 'Do you know it?',
          result: 'Yes'
        },
        {
          query: 'Do you know it?',
          result: 'No'
        }
      ],
      // diag
      visibleDiag1: false,
      deepMax: 0,
      nodeCategories: [...ActionCategories],
      nodeData: [],
      nodePosition: null,
      nodeLink: [],
      inputModels: {
        inputValue: null
      },
      modalWindowModels: {
        addTrigger: false,
        create: false,
        wait: false,
        email: false,
        condition: false,
        integration: false,
        notification: false,
        webhook: false,
        dragAndDrop: false
      },
      actionModalType: null,
      actionModalModel: null,
      modalType: null,
      hasChild: false,
      sizes: {
        circleRadius: 0,
        rectHeight: 0,
        customCircleRadius: 0
      },
      confirmTexts: {
        remove: 'Warning: Inserting this action here will delete all actions below it.'
      },
      strokeWidth: 2,
      tempData: {
        gotoNodes: [],
        nodeWithLinks: []
      }
    }
  ),
  beforeMount() {
    this.setSizesOfFigures()
  },
  mounted() {
    const inputElem = document.getElementById('node_data')

    if (inputElem.value) {
      const data = JSON.parse(inputElem.value)
      this.nodeData = data.map(node => nodesFactory.createNode(node, node.category))
    } else {
      let model = {
        key: 1,
        category: 0,
        text: 'START',
        value:
          {
            name: 'link'
          },
        parent: null,
        multiple: false
      }

      this.nodeData = [nodesFactory.createNode(model, model.category)]
    }

    this.modalType = modalWindowTypes.CREATE

    this.load()
  },
  computed: {
    modalWindowTypes() {
      return modalWindowTypes
    },
    actionTypes() {
      return ActionTypes
    },
    canEditInControlBox() {
      const category = this.nodeData[this.sourceNode]
        ? this.nodeData[this.sourceNode].category
        : ''

      switch (category) {
        case this.actionTypes.END_AUTOMATION:
          return false
        case this.actionTypes.GOTO:
          return false
        case 10:
          return false
        default:
          return true
      }
    }
  },
  methods: {
    setSizesOfFigures() {
      this.sizes.circleRadius = this.unitPixel / 6
      this.sizes.rectHeight = this.unitPixel * 2
      this.sizes.customCircleRadius = this.unitPixel * 3 / 6
    },
    registerSvgPanZoom(svgpanzoom) {
      this.svgpanzoom = svgpanzoom
    },
    center() {
      if (!this.svgpanzoom) {
        return
      }

      this.svgpanzoom.center()
    },
    zoomIn() {
      if (this.zoomRate <= 3.0) {
        this.zoomRate += 0.2
      }
    },
    zoomOut() {
      if (this.zoomRate >= 0.4) {
        this.zoomRate -= 0.2
      }
    },
    getSubTreeWidth(i, rm) {
      let w = 0
      let numChild = 0

      const children = []

      for (let index = 0; index < rm.nodeData.length; index++) {
        if (rm.nodeData[i].key === rm.nodeData[index].parent) {
          numChild++
          const cw = rm.getSubTreeWidth(index, rm)
          w += cw
          children.push({ index, cw })
        }
      }
      if (rm.nodeData[i].category === ActionTypes.CONDITION) {
        let maxCw = Math.max(...children.map(ch => ch.cw))
        let maxCh = maxCw
        if (maxCh < 0 || children.length < 2) maxCh = rm.unitPixel * 5
        let tw = maxCh * children.length
        let blackNode = rm.nodeData[i].question.length - numChild
        let captionW = rm.nodePosition[i].dx + rm.unitPixel
        if (blackNode > 0) {
          tw += maxCh * blackNode
          w += maxCh * numChild
          captionW += maxCh * numChild + rm.unitPixel
        }
        rm.nodePosition[i].tw = tw

        return Math.max(w, tw, captionW)
        // return w
      } else {
        if (numChild > 0) {
          rm.nodePosition[i].tw = Math.max(w, rm.nodePosition[i].dx + rm.unitPixel)

          return Math.max(w, rm.nodePosition[i].dx + rm.unitPixel)
        } else {
          w = rm.nodePosition[i].dx + rm.unitPixel
          rm.nodePosition[i].tw = Math.max(w, rm.nodePosition[i].dx + rm.unitPixel)

          return Math.max(w, rm.nodePosition[i].dx)
        }
      }
    },
    getNodeSize(rm) {
      const charW = 2 / 7

      rm.nodePosition = []

      for (let i = 0; i < rm.nodeData.length; i++) {
        // x: x(center), y:, dx: width of node, dy: height, tw: width of children(tree)
        rm.nodePosition.push(
          {
            x: 400,
            y: 30,
            dx: 0,
            dy: 0,
            tw: 0,
            ox: 0
          }
        )

        if (rm.nodeData[i].multiple) {
          rm.nodePosition[i].dx = 0
          rm.nodePosition[i].dy = rm.unitPixel * 6
        } else {
          let iconSize = rm.nodeData[i].icon.size ? rm.nodeData[i].icon.size : 0
          rm.nodePosition[i].dx = rm.unitPixel * charW * rm.nodeData[i].text.length + iconSize + rm.unitPixel / 2

          if (rm.nodeData[i].category === ActionTypes.CONDITION) {
            rm.nodePosition[i].dy = rm.unitPixel * 10 - rm.unitPixel / 2
          } else {
            rm.nodePosition[i].dy = rm.unitPixel * 5
          }

          if (rm.nodeData[i].same != null) {
            rm.nodePosition[i].dy = rm.unitPixel * 6
          }
        }
      }
    },
    getNthChildIndex(i, n, rm) {
      for (let index = 0; index < rm.nodeData.length; index++) {
        if (
          rm.nodeData[index].parent === rm.nodeData[i].key &&
          rm.nodeData[i].question[n] === rm.nodeData[index].answer) {
          return index
        }
      }
      return null
    },
    setNodePosition(i, rm) {
      let index = 0

      if (rm.nodeData[i].category === ActionTypes.CONDITION) {
        const dt = Math.max(rm.nodePosition[i].tw / 2, rm.unitPixel * 2)
        let sx = -dt
        let sx0 = 0
        let prevW = 0
        for (let qi = 0; qi < rm.nodeData[i].question.length; qi++) {
          let childIndex = rm.getNthChildIndex(i, qi, rm)

          if (childIndex == null) {
            sx += rm.unitPixel * 5 / 2 + prevW
            prevW = rm.unitPixel * 5 / 2
          } else {
            sx += dt / 2 + prevW
            rm.nodePosition[childIndex].x = rm.nodePosition[i].x + sx
            rm.nodePosition[childIndex].y = rm.nodePosition[i].y + rm.nodePosition[i].dy
            prevW = dt / 2
            rm.setNodePosition(childIndex, rm)
          }

          if (qi === 0) {
            sx0 = sx
          }
        }
        let tht = rm.nodePosition[i].y + rm.nodePosition[i].dy + rm.unitPixel * 10
        if (rm.canvas.height < tht) {
          rm.canvas.height = tht
        }
        rm.nodePosition[i].ox = -(sx + sx0) / 2
      } else {
        rm.nodeData.forEach(function(element) {
          if (index !== i) {
            if (rm.nodeData[index].parent === rm.nodeData[i].key) {
              rm.nodePosition[index].x = rm.nodePosition[i].x
              rm.nodePosition[index].y = rm.nodePosition[i].y + rm.nodePosition[i].dy

              let tht = rm.nodePosition[index].y + rm.nodePosition[index].dy + rm.unitPixel * 10

              if (rm.canvas.height < tht) {
                rm.canvas.height = tht
              }

              rm.setNodePosition(index, rm)
            }
          }

          index++
        })
      }
    },
    setEntryPosition(i) {
      // eslint-disable-next-line no-unused-vars
      const triggerNodesIndexes = []
      let startTriggersLength = 0

      for (let j = this.nodeData.length - 1; j >= 0; j--) {
        if (this.nodeData[i].key === this.nodeData[j].same) {
          triggerNodesIndexes.push(j)
          this.nodePosition[j].y = this.nodePosition[i].y
          startTriggersLength += this.nodePosition[j].dx
        }
      }

      if (!triggerNodesIndexes.length) return

      this.canvas.width = Math.max(this.canvas.width,
        startTriggersLength + this.unitPixel * 5 + this.strokeWidth * 15 * (triggerNodesIndexes.length + 1))
      this.nodePosition[0].x = this.canvas.width / 2

      const middleTrigger = Math.floor(triggerNodesIndexes.length / 2)
      const centerX = this.canvas.width / 2
      const shiftFromCenter =
        triggerNodesIndexes.length % 2 === 0
          ? this.nodePosition[triggerNodesIndexes[middleTrigger]].dx / 2
          : 0
      let currentX = centerX
      let prevNodeWidth = -shiftFromCenter

      for (let j = middleTrigger; j >= 0; j--) {
        currentX -= this.nodePosition[triggerNodesIndexes[j]].dx / 2 + prevNodeWidth
        prevNodeWidth = this.nodePosition[triggerNodesIndexes[j]].dx / 2
        this.nodePosition[triggerNodesIndexes[j]].x = currentX
      }

      currentX = centerX
      prevNodeWidth = shiftFromCenter

      for (let j = middleTrigger + 1; j < triggerNodesIndexes.length; j++) {
        currentX += this.nodePosition[triggerNodesIndexes[j]].dx / 2 + prevNodeWidth
        prevNodeWidth = this.nodePosition[triggerNodesIndexes[j]].dx / 2
        this.nodePosition[triggerNodesIndexes[j]].x = currentX
      }

      currentX += this.unitPixel * 5 / 2 + 14 + prevNodeWidth
      this.nodePosition[i].dx = currentX - centerX
    },
    getNodeInfo(index) {
      if (this.nodePosition === null) {
        return {
          x: 400,
          y: 30,
          dx: 0,
          dy: 0,
          tw: 0,
          ox: 0
        }
      }

      return this.nodePosition[index]
    },
    getChildInfo(i, question) {
      if (this.nodePosition === null) {
        return {
          x: 500,
          y: 500,
          dx: 100,
          dy: 100,
          tw: 100,
          ox: 0
        }
      }

      for (let index = 0; index < this.nodeData.length; index++) {
        if (
          this.nodeData[index].parent === this.nodeData[i].key &&
          question === this.nodeData[index].answer
        ) {
          return this.nodePosition[index]
        }
      }

      let qi

      for (qi = 0; qi < this.nodeData[i].question.length; qi++) {
        if (this.nodeData[i].question[qi] === question) {
          break
        }
      }

      // blank child
      if (qi === 0) {
        const blankX = this.nodePosition[i].x - Math.max(this.nodePosition[i].tw / 4, this.unitPixel)// + this.unitPixel + this.nodePosition[i].ox // + Math.max(0, this.nodePosition[i].dx - this.nodePosition[i].tw)

        return {
          x: blankX,
          y: 100,
          dx: this.unitPixel * 6,
          dy: this.unitPixel,
          tw: this.unitPixel * 2,
          ox: 0
        }
      }

      // let prevNodeInfo = this.getChildInfo(i, this.nodeData[i].question[qi - 1])

      return {
        x: this.nodePosition[i].x + Math.max(this.nodePosition[i].tw / 4, this.unitPixel),
        y: 100,
        dx: this.unitPixel,
        dy: this.unitPixel,
        tw: this.unitPixel * 2,
        ox: 0
      }
    },
    getNumberOfChild(index, question = null) {
      let count = 0

      for (let i = 0; i < this.nodeData.length; i++) {
        if (this.nodeData[index].key === this.nodeData[i].parent) {
          if (this.nodeData[index].category === ActionTypes.CONDITION) {
            if (question === this.nodeData[i].answer) {
              count++
            }
          } else {
            count++
          }
        }
      }

      return count
    },
    load() {
      const _rootThis = this
      const dragRectSelector = '#dragRect'
      const dropRectSelector = '#dropRect'
      const controlBoxSelector = '#controlBox'
      const dragCircleSelector = '#dragCircle'
      const dropCircleSelector = '#dropCircle'
      // const rectNodeSelector = '#rectNode'

      // dx, dy
      _rootThis.getNodeSize(_rootThis)
      _rootThis.getSubTreeWidth(0, _rootThis)
      _rootThis.canvas = {
        width: 500,
        height: 400
      }

      // initial position of tree (root's)
      _rootThis.canvas.width = Math.max(this.nodePosition[0].tw + 100, _rootThis.canvas.width)
      _rootThis.nodePosition[0].x = _rootThis.canvas.width / 2
      _rootThis.nodePosition[0].y = 50

      _rootThis.setEntryPosition(0)
      _rootThis.setNodePosition(0, _rootThis)
      _rootThis.sourceNode = null
      _rootThis.targetNode = null

      // d3 operation with drag and drop
      setTimeout(function() {
        // initialize graph
        let offsetX, offsetY

        d3.selectAll('.circle-node circle')
          .attr('stroke-width', 1)

        d3.select(dragRectSelector)
          .attr('opacity', 0)
          .attr('x', 0)
          .attr('y', 0)
          .attr('width', 1)
          .attr('height', 1)

        d3.select(dropRectSelector)
          .attr('opacity', 0)
          .attr('x', 0)
          .attr('y', 0)
          .attr('width', 1)
          .attr('height', 1)

        d3.select(dragCircleSelector)
          .attr('opacity', 0)

        d3.select(dropCircleSelector)
          .attr('opacity', 0)

        d3.select(controlBoxSelector)
          .attr('opacity', 0)

        d3.select('.line-dot')
          .raise()

        // node drag and drop using d3
        const drag = d3.drag()
          .on('start', () => {
            _rootThis.draging = true
            offsetX = null
          })
          .on('drag', function() {
            if (offsetX == null) {
              // eslint-disable-next-line no-undef
              offsetX = d3.event.x - $(this).attr('x')
              // eslint-disable-next-line no-undef
              offsetY = d3.event.y - $(this).attr('y')
            }

            d3.select(this)
              .attr('x', d3.event.x - offsetX)
              .attr('y', d3.event.y - offsetY)
              .attr('opacity', 0.6)

            d3.select(controlBoxSelector).attr('opacity', 0)

            _rootThis.targetNode = null

            for (let i = 0; i < _rootThis.nodeData.length; i++) {
              if (i === _rootThis.sourceNode || _rootThis.nodeData[i].same != null) {
                continue
              }

              let cx, cy

              if (_rootThis.nodeData[i].category === ActionTypes.CONDITION) {
                d3.selectAll('.circle-' + i).each(function(d) {
                  cx = d3.select(this).attr('x') * 1 + d3.select(this).attr('width') / 2
                  cy = d3.select(this).attr('y') * 1 + d3.select(this).attr('height') / 2

                  let dx = cx - d3.event.x
                  let dy = cy - d3.event.y
                  let w = _rootThis.nodePosition[_rootThis.sourceNode].dx
                  let h = _rootThis.nodePosition[_rootThis.sourceNode].dy / 2

                  let computedData = dx * dx / (w * w) + dy * dy / (h * h)

                  if (computedData <= 1) {
                    _rootThis.targetNode = i
                    _rootThis.targetQuestion = d3.select(this).attr('data-answer')

                    d3.selectAll('.circle-node circle')
                      .attr('stroke-width', 1)

                    d3.select(this).select('circle')
                      .attr('stroke-width', 2)

                    d3.select(dropRectSelector)
                      .attr('x', cx - _rootThis.nodePosition[_rootThis.sourceNode].dx / 2)
                      .attr('y', cy - _rootThis.unitPixel)
                      .attr('width', _rootThis.nodePosition[_rootThis.sourceNode].dx)
                      .attr('height', _rootThis.unitPixel * 2)
                      .attr('opacity', 1)
                  }
                })
              } else {
                // if (_rootThis.nodeData[i].goto!=null) continue;
                let cx = 0
                let cy = 0

                try {
                  cx = d3.select('.circle-' + i).attr('x') * 1 + d3.select('.circle-' + i).attr('width') / 2
                  cy = d3.select('.circle-' + i).attr('y') * 1 + d3.select('.circle-' + i).attr('height') / 2
                } catch (e) {}

                let dx = cx - d3.event.x
                let dy = cy - d3.event.y
                let w = _rootThis.nodePosition[_rootThis.sourceNode].dx / 2
                let h = _rootThis.unitPixel

                let computedData = dx * dx / (w * w) + dy * dy / (h * h)

                if (computedData <= 1) {
                  _rootThis.targetNode = i

                  d3.select('.circle-' + i + ' circle')
                    .attr('stroke-width', 2)

                  d3.select(dropRectSelector)
                    .attr('x', cx - _rootThis.nodePosition[_rootThis.sourceNode].dx / 2)
                    .attr('y', cy - _rootThis.unitPixel)
                    .attr('width', _rootThis.nodePosition[_rootThis.sourceNode].dx)
                    .attr('height', _rootThis.unitPixel * 2)
                    .attr('opacity', 1)
                }
              }
            }

            if (_rootThis.targetNode == null) {
              d3.select(dropRectSelector)
                .attr('opacity', 0)
                .attr('x', 0)
                .attr('y', 0)
                .attr('width', 1)
                .attr('height', 1)

              d3.selectAll('.circle-node circle')
                .attr('stroke-width', 1)
            }
          })
          .on('end', function(e) {
            // alert(this)
            _rootThis.draging = false

            d3.select(dropRectSelector)
              .attr('opacity', 0)
              .attr('x', 0)
              .attr('y', 0)
              .attr('width', 1)
              .attr('height', 1)

            d3.select(dragRectSelector)
              .attr('opacity', 0)
              .attr('x', 0)
              .attr('y', 0)
              .attr('width', 1)
              .attr('height', 1)

            if (_rootThis.targetNode != null) {
              _rootThis.modalWindowModels.dragAndDrop = true
              _rootThis.modalType = modalWindowTypes.DRAG
            }
          })

        d3.select(dragRectSelector).call(drag)

        // --------------------------------------------------------------------

        // link (goto) drag and drop
        const dragJointCircle = d3.drag()
          .on('start', () => {
            _rootThis.draging = true
            offsetX = null
          })
          .on('drag', function() {
            if (offsetX == null) {
              // eslint-disable-next-line no-undef
              offsetX = d3.event.x - $(this).attr('cx')
              // eslint-disable-next-line no-undef
              offsetY = d3.event.y - $(this).attr('cy')
            }

            d3.select(this)
              .attr('cx', d3.event.x - offsetX)
              .attr('cy', d3.event.y - offsetY)
              .attr('opacity', 0.6)

            _rootThis.targetNode = null

            const bottomCircle = d3.selectAll('.circle-top-joint')
            const selPoint = this

            bottomCircle.each(function() {
              let compute = d3.select(selPoint).attr('cx') - d3.select(this).attr('cx')
              compute *= d3.select(selPoint).attr('cx') - d3.select(this).attr('cx')
              compute += d3.select(selPoint).attr('cy') - d3.select(this).attr('cy')
              compute *= d3.select(selPoint).attr('cy') - d3.select(this).attr('cy')

              let dis = Math.sqrt(compute)

              if (dis < _rootThis.unitPixel) {
                d3.select(dropCircleSelector)
                  .attr('cx', d3.select(this).attr('cx'))
                  .attr('cy', d3.select(this).attr('cy'))
                  .attr('opacity', 1)
                _rootThis.targetNode = this.getAttribute('data-index')
              }
            })
          })
          .on('end', function(e) {
            // alert(this)
            _rootThis.draging = false

            d3.select(dropCircleSelector)
              .attr('opacity', 0)

            d3.select(dragCircleSelector)
              .attr('opacity', 0)

            if (_rootThis.targetNode != null && _rootThis.targetNode !== _rootThis.sourceNode) {
              if (_rootThis.hasChildren(_rootThis.sourceNode, _rootThis.hasChildren(_rootThis.sourceNode, _rootThis.sourceQuestion))) {
                alert('Cannot goto another node from this node')
              } else {
                _rootThis.addLink()
                // _rootThis.sourceNode = null
                _rootThis.targetNode = null
                _rootThis.sourceQuestion = null
              }
            }
          })

        d3.select(dragCircleSelector).call(dragJointCircle)

        // link (goto) line remove
        d3.selectAll('.goto-line')
          .on('click', function() {
            _rootThis.sourceNode = this.getAttribute('data-index')
            _rootThis.removeGoto()
          })

        // link (goto) mouse over
        d3.selectAll('.circle-term-joint')
          .on('mouseover', function() {
            if (!_rootThis.draging) {
              _rootThis.sourceNode = this.getAttribute('data-index')
              _rootThis.sourceQuestion = this.getAttribute('data-question')
            }

            if (_rootThis.sourceNode != null) {
              d3.select(dragCircleSelector)
                .attr('cx', d3.select(this).attr('cx'))
                .attr('cy', d3.select(this).attr('cy'))
                .attr('opacity', 1)
            }
          })

        // node mouse over
        _rootThis.setNodeEvents()
      }, 0)
    },
    saveTree() {
      this.msg = 'Please check console to show JSON.'
      console.table(this.nodeData)
      console.table(JSON.stringify(this.nodeData))
      const elem = document.getElementById('output_node_data')
      elem.value = JSON.stringify(this.nodeData)
    },
    getChildIndex(index, question) {
      for (let i = 0; i < this.nodeData.length; i++) {
        if (this.nodeData[index].key === this.nodeData[i].parent) {
          if (question == null) {
            return i
          } else {
            if (this.nodeData[i].answer === question) {
              return i
            }
          }
        }
      }

      return null
    },

    showCreateModal(index, question = null, key) {
      this.findChild(key)
      this.visibleDiag1 = true
      // this.msg = question + index
      this.selectedNode = index
      this.selectedQuestion = question
      this.selectedChild = this.getChildIndex(index, question)
    },
    findChild(key) {
      this.nodeData.forEach(n => {
        if (n.parent === key) {
          this.hasChild = true
        }
      })
    },
    hideCreateModal() {
      this.visibleDiag1 = false
      this.enableAddNode = true
    },
    hideActionModal(data) {
      const {
        id
      } = data

      this.actionModalType = modalWindowTypes.CREATE
      this.selectedCategory = id

      this.hideCreateModal()

      if (id === ActionTypes.END_AUTOMATION || id === ActionTypes.GOTO) {
        this.addNode({})
        return
      }

      this.modalWindowModels[this.getCategoryName(id)] = true
    },
    hideDiag2() {
      for (const key in this.modalWindowModels) {
        this.modalWindowModels[key] = false
      }

      this.modalType = modalWindowTypes.CREATE
      this.actionModalModel = null

      this.selectedCategory = null
      this.selectedChild = null
      this.selectedNode = null
    },
    getNewKey() {
      let maxKey = 0

      this.nodeData.forEach(function(node) {
        if (maxKey < node.key) {
          maxKey = node.key
        }
      })

      return maxKey + 1
    },
    verifyCondition() {
      for (let i = 0; i < this.inputCondition.length - 1; i++) {
        for (let j = i + 1; j < this.inputCondition.length; j++) {
          if (this.inputCondition[i].result.trim() === this.inputCondition[j].result.trim()) {
            return false
          }
        }
      }

      return true
    },
    getMultipleEntry(i) {
      let entries = []

      for (let j = 0; j < this.nodeData.length; j++) {
        if (this.nodeData[i].key === this.nodeData[j].same) {
          entries.push(this.nodeData[j])
        }
      }

      return entries
    },
    getIndexFromKey(key) {
      for (let i = 0; i < this.nodeData.length; i++) {
        if (this.nodeData[i].key === key) {
          return i
        }
      }

      return null
    },
    addEntry(index) {
      this.modalWindowModels.addTrigger = true
    },
    addTrigger(data) {
      const parentTriggerKey = this.nodeData[0].key

      let model = {
        key: this.getNewKey() + 1,
        category: 10,
        text: data.text,
        value: data,
        question: null,
        same: parentTriggerKey
      }

      this.nodeData.push(nodesFactory.createNode(model, model.category))

      this.load()
      this.modalWindowModels.addTrigger = false
    },
    isSameBranch(one, two, question, rm) {
      if (rm.nodeData[one].parent === rm.nodeData[two].key) {
        if (question != null) {
          return rm.nodeData[one].answer === question
        } else {
          return true
        }
      }

      if (rm.nodeData[one].parent == null) {
        return false
      }

      for (let i = 0; i < rm.nodeData.length; i++) {
        if (rm.nodeData[i].key === rm.nodeData[one].parent) {
          return rm.isSameBranch(i, two, question, rm)
        }
      }

      return false
    },
    getNearChildIndex(index, question) {
      for (let i = 0; i < this.nodeData.length; i++) {
        if (this.nodeData[i].parent === this.nodeData[index].key) {
          if (this.nodeData[index].category === ActionTypes.CONDITION) { // condition?
            if (question === this.nodeData[i].answer) {
              return i
            }
          } else {
            return i
          }
        }
      }
      return null
    },
    getTerminalIndex(index, rm) {
      for (let i = 0; i < this.nodeData.length; i++) {
        if (rm.nodeData[i].parent === rm.nodeData[index].key) {
          return rm.getTerminalIndex(i, rm)
        }
      }

      return index
    },
    addLink() {
      const key = this.nodeData[this.targetNode].key

      if (this.nodeData[this.sourceNode].category === ActionTypes.CONDITION) {
        if (this.nodeData[this.sourceNode].goto == null) {
          this.nodeData[this.sourceNode].goto = {}
        }

        this.nodeData[this.sourceNode].goto[this.sourceQuestion] = key
      } else {
        this.nodeData[this.sourceNode].goto = key
      }

      this.load()
    },
    hasChildren(index, question) {
      for (let i = 0; i < this.nodeData.length; i++) {
        if (this.nodeData[i].parent === this.nodeData[index].key) {
          if (question != null) {
            if (this.nodeData[i].answer === question) {
              return true
            }
          } else {
            return true
          }
        }
      }
      return false
    },
    addNode(data) {
      let key = this.getNewKey()
      let question = []
      let value = data

      if (this.selectedChild !== null) {
        if (this.selectedCategory === this.actionTypes.CONDITION) {
          if (data.questions) {
            this.nodeData[this.selectedChild].answer = data.questions[0]
          }
          this.nodeData[this.selectedChild].parent = key
        } else if (
          this.selectedCategory === this.actionTypes.END_AUTOMATION ||
          this.selectedCategory === this.actionTypes.GOTO
        ) {
          const answer = confirm(this.confirmTexts.remove)

          if (answer) {
            const child = this.getNearChildIndex(this.selectedNode, this.selectedQuestion)
            if (child) {
              this.deleteAllChildren(child)
            }
          } else {
            return
          }
        } else this.nodeData[this.selectedChild].parent = key
      }

      let model = {
        key,
        category: this.selectedCategory,
        answer: this.selectedQuestion,
        value,
        parent: this.nodeData[this.selectedNode].key,
        question,
        goto: null
      }

      this.nodeData.push(nodesFactory.createNode(model, model.category))
      this.load()

      this.hideDiag2()
      this.modalType = modalWindowTypes.CREATE
      this.hasChild = false
    },
    editNode() {
      const node = this.nodeData[this.sourceNode]
      const categoryName = this.getCategoryName(node.category)
      this.modalType = modalWindowTypes.EDIT
      this.actionModalType = modalWindowTypes.EDIT

      this.actionModalModel = node
      this.modalWindowModels[categoryName] = true
    },
    saveNode(nodeValue) {
      const node = this.nodeData[this.sourceNode]

      node.changeValue(nodeValue)
      this.hideDiag2()
      this.load()
    },
    removeNode() {
      if (!confirm('Are you sure remove this node?')) {
        return
      }

      if (this.sourceNode == null) {
        alert('Can not find selected node index!')
        return
      }

      let parentKey = this.nodeData[this.sourceNode].parent
      const removeNode = this.nodeData[this.sourceNode]
      // let parentIndex = this.getIndexFromKey(parentKey)

      if (this.nodeData[this.sourceNode].goto != null) {
        alert('This node has linked one')
        return
      }

      // remove all link to that node from goto actions
      const gotoActions = this.nodeData.filter(n => n.category === ActionTypes.GOTO)
      gotoActions.forEach(e => {
        if (e.goto === removeNode.key) {
          e.goto = null
        }
      })

      if (this.nodeData[this.sourceNode].category === ActionTypes.CONDITION) {
        if (this.hasChildren(this.sourceNode)) {
          alert('This node has some children. Can not remove!')
          return
        } else {
          this.nodeData.splice(this.sourceNode, 1)
        }
      } else {
        let childIndex = this.getNearChildIndex(this.sourceNode)

        if (childIndex != null) {
          this.nodeData[childIndex].parent = parentKey
          this.nodeData[childIndex].answer = this.nodeData[this.sourceNode].answer
        }

        this.nodeData.splice(this.sourceNode, 1)
      }

      this.load()
    },
    removeGoto() {
      if (this.sourceNode != null) {
        this.nodeData[this.sourceNode].goto = null
        this.load()
      }
    },
    moveCopyNode(option) {
      const rm = this
      let termIndex, nearIndex
      // let confirmEndAction = 'Warning: Moving an "End this automation" action here will delete all actions below it.'

      rm.hideDiag2()

      // if it has goto, cannot move
      if (rm.nodeData[rm.sourceNode].goto !== null) {
        if (rm.nodeData[rm.sourceNode].goto.length !== 0) {
          alert('Can not move it because it was linked a node')
          return
        }
      }

      switch (option.id) {
        // move all branch
        case 1:
          if (
            rm.isSameBranch(rm.sourceNode, rm.targetNode, rm.targetQuestion, rm) ||
            rm.isSameBranch(rm.targetNode, rm.sourceNode, null, rm)
          ) {
            alert('same branch!')
          } else {
            const nodeToInsertBeforeIndex = rm.targetNode
            const nodeAfterInsertIndex = rm.getNearChildIndex(rm.targetNode, rm.targetQuestion)
            const nodeToInsertIndex = rm.sourceNode

            if (nodeAfterInsertIndex === null) {
              rm.nodeData[nodeToInsertIndex].parent = rm.nodeData[nodeToInsertBeforeIndex].key
              rm.nodeData[nodeToInsertIndex].answer = rm.targetQuestion
              this.load()
              return
            }

            if (nodeAfterInsertIndex && rm.nodeData[rm.sourceNode].category === ActionTypes.GOTO) {
              alert('Can not move it')
              return
            }

            // if condition
            if (rm.nodeData[nodeToInsertIndex].category === ActionTypes.CONDITION) {
              // if has end action
              if (this.hasDangerAction(nodeToInsertIndex)) {
                this.removeGotosLinks(nodeToInsertIndex, nodeToInsertBeforeIndex)
                rm.nodeData[nodeToInsertIndex].parent = rm.nodeData[nodeToInsertBeforeIndex].key
                rm.nodeData[nodeToInsertIndex].answer = rm.targetQuestion
                this.deleteAllChildren(nodeAfterInsertIndex)
              } else {
                rm.nodeData[nodeToInsertIndex].parent = rm.nodeData[nodeToInsertBeforeIndex].key
                let childIndex = this.getLastChildOfConditionsTree(nodeToInsertIndex)

                if (childIndex) {
                  rm.nodeData[nodeAfterInsertIndex].parent = rm.nodeData[childIndex].key
                  rm.nodeData[nodeAfterInsertIndex].answer = rm.nodeData[childIndex].question[0]
                } else {
                  rm.nodeData[nodeAfterInsertIndex].parent = rm.nodeData[nodeToInsertIndex].key
                  rm.nodeData[nodeAfterInsertIndex].answer = rm.nodeData[nodeToInsertIndex].question[0]
                }
              }
            } else {
              if (this.hasDangerAction(nodeToInsertIndex)) {
                this.removeGotosLinks(nodeToInsertIndex, nodeToInsertBeforeIndex)
                rm.nodeData[nodeToInsertIndex].parent = rm.nodeData[nodeToInsertBeforeIndex].key
                rm.nodeData[nodeToInsertIndex].answer = rm.targetQuestion
                this.deleteAllChildren(nodeAfterInsertIndex)
              } else {
                rm.nodeData[nodeToInsertIndex].parent = rm.nodeData[nodeToInsertBeforeIndex].key
                rm.nodeData[nodeToInsertIndex].answer = rm.targetQuestion

                let childIndex = this.getLastChildOfConditionsTree(nodeToInsertIndex)

                if (childIndex) {
                  rm.nodeData[nodeAfterInsertIndex].parent = rm.nodeData[childIndex].key
                } else {
                  rm.nodeData[nodeAfterInsertIndex].parent = rm.nodeData[nodeToInsertIndex].key
                }

                rm.nodeData[nodeAfterInsertIndex].answer = ''
              }
            }
          }

          this.load()
          break
        case 2: // alone
          if (
            (rm.nodeData[rm.sourceNode].parent === rm.nodeData[rm.targetNode].key &&
              (!rm.nodeData[rm.sourceNode].answer ||
              (rm.nodeData[rm.sourceNode].answer && rm.nodeData[rm.sourceNode].answer === rm.targetQuestion))) ||
            +rm.targetNode === +rm.sourceNode
          ) {
            return
          }

          if (
            rm.hasChildren(rm.sourceNode) &&
            rm.nodeData[rm.sourceNode].category === ActionTypes.CONDITION) {
            alert('Сan not move it because it has some children or linked ones')
            return
          }

          if (rm.nodeData[rm.sourceNode].goto !== null) {
            alert('Сan not move it because it has some children or linked ones')
            return
          }

          // child index of source node
          nearIndex = rm.getNearChildIndex(rm.sourceNode, null)

          if (nearIndex) {
            rm.nodeData[nearIndex].parent = rm.nodeData[rm.sourceNode].parent
            rm.nodeData[nearIndex].answer = rm.nodeData[rm.sourceNode].answer
          }

          // child index of target node
          nearIndex = rm.getNearChildIndex(rm.targetNode, rm.targetQuestion)

          if (nearIndex && rm.nodeData[rm.sourceNode].category === ActionTypes.GOTO) {
            alert('Can not move it')
            return
          }

          // settings end action
          if (nearIndex && rm.nodeData[rm.sourceNode].category === ActionTypes.END_AUTOMATION) {
            let text = 'Warning: Moving an "End this automation" action here will delete all actions below it.'

            if (confirm(text)) {
              rm.nodeData[rm.sourceNode].parent = rm.nodeData[rm.targetNode].key // write parent key
              rm.nodeData[rm.sourceNode].answer = rm.nodeData[nearIndex].answer // write branch name
              this.deleteAllChildren(nearIndex)
              rm.load()
              return
            } else {
              return
            }
          }

          if (nearIndex) {
            rm.nodeData[nearIndex].parent = rm.nodeData[rm.sourceNode].key

            if (rm.nodeData[rm.sourceNode].category === ActionTypes.CONDITION) {
              rm.nodeData[nearIndex].answer = rm.nodeData[rm.sourceNode].question[0]
            } else {
              rm.nodeData[nearIndex].answer = null
            }
          }

          // move sub tree
          rm.nodeData[rm.sourceNode].parent = rm.nodeData[rm.targetNode].key
          rm.nodeData[rm.sourceNode].answer = rm.targetQuestion
          rm.load()

          break
      }
    },
    setNodeEvents() {
      const _rootThis = this
      const dragRectSelector = '#dragRect'
      const controlBoxSelector = '#controlBox'
      const rectNodeSelector = '#rectNode'
      const addNodeSelector = '#addNodeCircle'
      const circleNodeSelector = '#circleNode'
      const boxCoords = {
        x: d3.select(controlBoxSelector).attr('x'),
        y: d3.select(controlBoxSelector).attr('y')
      }
      const rectCoords = {
        x: d3.select(dragRectSelector).attr('x'),
        y: d3.select(dragRectSelector).attr('y')
      }
      const circleCoords = {
        x: d3.select(addNodeSelector).attr('x'),
        y: d3.select(addNodeSelector).attr('y')
      }

      // hover on action node
      d3.selectAll('.action')
        .on('mouseover', function() {
          if (!_rootThis.draging && this.getAttribute('data-index')) {
            _rootThis.sourceNode = this.getAttribute('data-index')
          }

          if (_rootThis.sourceNode !== null) {
            d3.select(dragRectSelector)
              .attr('x', +d3.select(rectNodeSelector + _rootThis.sourceNode).attr('x') + _rootThis.strokeWidth)
              .attr('y', +d3.select(rectNodeSelector + _rootThis.sourceNode).attr('y') + _rootThis.strokeWidth)
              .attr('width', d3.select(rectNodeSelector + _rootThis.sourceNode).attr('width') - 4)
              .attr('height', d3.select(rectNodeSelector + _rootThis.sourceNode).attr('height') - 4)
              .attr('opacity', 0.3)
              .on('mouseover', function() {
                let computedX = d3.select(rectNodeSelector + _rootThis.sourceNode).attr('x') * 1
                computedX += d3.select(rectNodeSelector + _rootThis.sourceNode).attr('width') * 1
                computedX -= d3.select(controlBoxSelector).attr('width') / 1.8 + 4

                let computedY = d3.select(rectNodeSelector + _rootThis.sourceNode).attr('y') - _rootThis.unitPixel - 40

                d3.select(controlBoxSelector)
                  .attr('x', computedX)
                  .attr('y', computedY)
                  .attr('opacity', 1)
              })
              .on('mouseleave', function() {
                let focus = false

                d3.select(controlBoxSelector)
                  .on('mouseenter', function() {
                    focus = true
                  })
                  .on('mouseleave', function() {
                    d3.select(controlBoxSelector)
                      .attr('x', boxCoords.x)
                      .attr('y', boxCoords.y)
                      .attr('opacity', 0)

                    d3.select(dragRectSelector)
                      .attr('x', rectCoords.x)
                      .attr('y', rectCoords.y)
                      .attr('opacity', 0)
                  })

                setTimeout(function() {
                  if (!focus) {
                    d3.select(controlBoxSelector)
                      .attr('x', boxCoords.x)
                      .attr('y', boxCoords.y)
                      .attr('opacity', 0)

                    d3.select(dragRectSelector)
                      .attr('x', rectCoords.x)
                      .attr('y', rectCoords.y)
                      .attr('opacity', 0)
                  }
                }, 0)
              })
          }
        })

      // hover on trigger node
      d3.selectAll('.trigger')
        .on('mouseover', function() {
          if (!_rootThis.draging && this.getAttribute('data-index')) {
            _rootThis.sourceNode = this.getAttribute('data-index')
          }

          if (_rootThis.sourceNode !== null) {
            let computedX = d3.select(rectNodeSelector + _rootThis.sourceNode).attr('x') * 1
            computedX += d3.select(rectNodeSelector + _rootThis.sourceNode).attr('width') * 1
            computedX -= d3.select(controlBoxSelector).attr('width') / 1.8 + 4

            let computedY = d3.select(rectNodeSelector + _rootThis.sourceNode).attr('y') - _rootThis.unitPixel - 40

            d3.select(controlBoxSelector)
              .attr('x', computedX)
              .attr('y', computedY)
              .attr('opacity', 1)
          }
        })
        .on('mouseleave', function() {
          let focus = false

          d3.select(controlBoxSelector)
            .on('mouseenter', function() {
              focus = true
            })
            .on('mouseleave', function() {
              d3.select(controlBoxSelector)
                .attr('x', boxCoords.x)
                .attr('y', boxCoords.y)
                .attr('opacity', 0)
            })

          setTimeout(function() {
            if (!focus) {
              d3.select(controlBoxSelector)
                .attr('x', boxCoords.x)
                .attr('y', boxCoords.y)
                .attr('opacity', 0)
            }
          }, 0)
        })

      d3.selectAll('.add-node')
        .on('mouseover', function() {
          if (!_rootThis.draging && this.getAttribute('data-index')) {
            _rootThis.sourceNode = this.getAttribute('data-index')
          }

          if (_rootThis.sourceNode !== null) {
            let x = +d3.select(circleNodeSelector + _rootThis.sourceNode).attr('x') + _rootThis.strokeWidth
            let y = +d3.select(circleNodeSelector + _rootThis.sourceNode).attr('y') + _rootThis.strokeWidth
            let coef = 1.7
            let r = _rootThis.sizes.customCircleRadius * coef
            d3.select(addNodeSelector)
              .attr('x', x + r / coef - r)
              .attr('y', y + r / coef - r)
              .attr('width', 2 * r)
              .attr('height', 2 * r)
              .attr('opacity', 1)
          }
        })
        .on('mouseleave', function() {
          setTimeout(function() {
            d3.select(addNodeSelector)
              .attr('cx', circleCoords.x)
              .attr('cy', circleCoords.y)
              .attr('width', 0)
              .attr('height', 0)
              .attr('opacity', 0)
          }, 0)
        })
    },
    getCategoryName(id) {
      return this.nodeCategories.find(e => e.id === id).name || ''
    },
    /**
     * Recursively deletes all child nodes.
     *
     * @param startIndex
     */
    deleteAllChildren(startIndex) {
      this.deleteChild(startIndex)
      this.nodeData = this.nodeData.filter(n => n.key)
    },
    deleteChild(startIndex) {
      if (startIndex && this.nodeData[startIndex].category === ActionTypes.CONDITION) {
        let conditionNodeKey = this.nodeData[startIndex].key
        let branches = this.nodeData[startIndex].question

        branches.forEach(branch => {
          let childIndex = this.nodeData.findIndex(n => (n.parent === conditionNodeKey) && n.answer === branch)
          if (childIndex >= 0) {
            this.deleteChild(childIndex)
          }
        })
      }

      let childIndex = this.getNearChildIndex(startIndex)

      if (childIndex !== null) {
        this.deleteChild(childIndex)
      }

      const gotoActions = this.nodeData.filter(n => n.category === ActionTypes.GOTO)
      gotoActions.forEach(e => {
        if (e.goto === this.nodeData[startIndex].key) {
          e.goto = null
        }
      })

      this.nodeData[startIndex] = {}
    },
    hasDangerAction(startIndex) {
      if (startIndex === null) {
        return false
      }

      if (this.nodeData[startIndex].category === this.actionTypes.CONDITION) {
        let childIndex = this.getNearChildIndex(startIndex, this.nodeData[startIndex].question[0])
        return this.hasDangerAction(childIndex)
      }

      if ([this.actionTypes.END_AUTOMATION, this.actionTypes.GOTO].includes(this.nodeData[startIndex].category)) {
        return true
      }

      let childIndex = this.getNearChildIndex(startIndex)
      return this.hasDangerAction(childIndex)
    },
    /**
     * Get last child index.
     * @param startIndex
     */
    getLastChildOfConditionsTree(startIndex) {
      if (startIndex === null) {
        return null
      }

      if (this.nodeData[startIndex].category === ActionTypes.CONDITION) {
        let childIndex = this.getNearChildIndex(startIndex, this.nodeData[startIndex].question[0])

        if (childIndex === null) {
          return startIndex
        }

        if (this.nodeData[childIndex].category === ActionTypes.CONDITION) {
          this.nodeData[childIndex].parent = this.nodeData[startIndex].key
        }

        return this.getLastChildOfConditionsTree(childIndex)
      }

      let childIndex = this.getNearChildIndex(startIndex)

      if (childIndex === null) {
        return startIndex
      }

      return this.getLastChildOfConditionsTree(childIndex)
    },
    getAllRemovingNodes(startIndex) {
      if (startIndex && this.nodeData[startIndex].category === this.actionTypes.CONDITION) {
        let conditionNodeKey = this.nodeData[startIndex].key
        let branches = this.nodeData[startIndex].question

        branches.forEach(branch => {
          let childIndex = this.nodeData.findIndex(n => (n.parent === conditionNodeKey) && n.answer === branch)

          if (childIndex >= 0) {
            this.tempData.nodeWithLinks.push(this.nodeData[childIndex])
            this.getAllRemovingNodes(childIndex)
          }
        })
      }

      let childIndex = this.getNearChildIndex(startIndex)

      if (childIndex !== null) {
        this.tempData.nodeWithLinks.push(this.nodeData[childIndex])
        this.getAllRemovingNodes(childIndex)
      }
    },
    getAllGotos(startIndex) {
      if (startIndex && this.nodeData[startIndex].category === this.actionTypes.CONDITION) {
        let conditionNodeKey = this.nodeData[startIndex].key
        let branches = this.nodeData[startIndex].question

        branches.forEach(branch => {
          let childIndex = this.nodeData.findIndex(n => (n.parent === conditionNodeKey) && n.answer === branch)
          if (childIndex >= 0) {
            if (this.nodeData[childIndex].category === this.actionTypes.GOTO) {
              this.tempData.gotoNodes.push(this.nodeData[childIndex])
            }
            this.getAllGotos(childIndex)
          }
        })
      }

      let childIndex = this.getNearChildIndex(startIndex)

      if (childIndex !== null) {
        if (this.nodeData[childIndex].category === this.actionTypes.GOTO) {
          this.tempData.gotoNodes.push(this.nodeData[childIndex])
        }
        this.getAllGotos(childIndex)
      }
    },
    removeGotosLinks(nodeToInsertIndex, nodeToInsertBeforeIndex) {
      // search all gotos in branch
      this.getAllGotos(nodeToInsertIndex)
      // search all removing nodes
      this.getAllRemovingNodes(nodeToInsertBeforeIndex)

      // delete all links
      this.tempData.nodeWithLinks.forEach(nodeLink => {
        this.tempData.gotoNodes.forEach(gotoNode => {
          if (gotoNode.goto === nodeLink.key) {
            gotoNode.goto = null
          }
        })
      })

      // clear temp data
      this.tempData.gotoNodes = []
      this.tempData.nodeWithLinks = []
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ParentCanvas.vue